var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.calculated
    ? _c(
        "span",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [
          _vm._v(
            "\n  " + _vm._s(_vm.formattedValue || _vm.placeholder) + "\n  "
          ),
          _vm.loading ? _c("inline-loader") : _vm._e(),
        ],
        1
      )
    : _c("div", [
        _c("input", {
          directives: [
            {
              name: "mask",
              rawName: "v-mask",
              value: {
                mask: _vm.decimalMask,
                placeholder: _vm.decimalPlaceholder,
                greedy: false,
                showMaskOnHover: false,
              },
              expression:
                "{\n      mask: decimalMask,\n      placeholder: decimalPlaceholder,\n      greedy: false,\n      showMaskOnHover: false\n    }",
            },
          ],
          ref: "input",
          attrs: {
            id: _vm.labelValue,
            type: "text",
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
          },
          domProps: { value: _vm.formattedValue },
          on: { change: _vm.handleChange },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            class: { "d-none": _vm.hiddenLabel },
            attrs: { for: _vm.labelValue },
          },
          [_vm._v(_vm._s(_vm.label))]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }